module.exports = __webpack_public_path__ + "static/media/read-ai.8dd961e1.png";